<template>
    <div>
        
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">
                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data" class="workflow-tabs">
                            <div class="tab-content">
                                <input type="hidden" name="_token" :value="csrf">
                                <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                            
                                
                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="">Title</label>
                                            <input type="text" class="form-control rounded" name="questionBase[name]" :value="this.name">
                                        </div>
                                    </div>
                                    
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="">Description</label>
                                            <input type="text" class="form-control rounded" name="questionBase[description]" :value="this.description">
                                        </div>
                                    </div>
                                    
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label for="">Sorting</label>
                                            <input type="text" class="form-control rounded" name="questionBase[sorting]" :value="this.sorting">
                                        </div>
                                    </div>
                                    
                                </div>   
                                
                                
                                <div class="row">
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">Settings Rows Matrix</p>
                                    </div>
                                </div>
                                <div class="row mb-3">    
                                    <div class="col-12">
                                        <div class="form-group">
                                            <div class="row mb-2">
                                                <div class="col-2">
                                                    <h6>Id Row</h6>
                                                </div>
                                                <div class="col-6">
                                                    <h6>Label Row</h6>
                                                </div>
                                            </div>
                                            <div class="row mb-1" v-bind:class="{ hidden: key=='row0' }" v-for="(label,key) in matrixRows" :key="key">
                                                <div class="col-2">
                                                    <h6>{{key}}</h6>
                                                </div>
                                                <div class="col-6">
                                                    <input class="form-control rounded" :name="'questionSettings[rows]['+key+'][question]'" :value="label">
                                                </div>
                                                <div class="col-4 text-right">
                                                    <button type="button" class="btn btn--only-icon-rounded btn--danger float-right" @click="rmRowMatrix(key)" ><i class="fas fa-times"></i></button>
                                                  </div>
                                                </div> 
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="row mb-3 align-items-end">
                                        <div class="col-2">
                                            <div class="form-group">
                                                <label>Id Row</label>
                                                <input id="elemTxt" class="form-control rounded" v-model="newIdRow" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <label>Label Row</label>
                                                <input id="elemLabel" class="form-control rounded" v-model="newIdLabel" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-4 text-right">
                                            <div class="form-group">
                                                <button id="addElemBtn" type="button" class="btn btn--green" @click="addRowMatrix">Add new row</button>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-12">
                                            <p class="tab-description mt-3 mb-2">Settings Rows Answers</p>
                                        </div>
                                    </div>
                                    
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <div class="form-group">
                                                <div class="row mb-2">
                                                    <div class="col-2">
                                                        <h6>Id</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <h6>Label</h6>
                                                    </div>
                                                    <div class="col-3">
                                                        <h6>Type</h6>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <div class="row mb-1" v-for="(row,key) in matrixAnswers" :key="key">
                                                    <div class="col-2">
                                                        <h6>{{key}}</h6>
                                                    </div>
                                                    <div class="col-6">
                                                        <input class="form-control rounded" :name="'questionSettings[answers]['+key+'][label]'" :value="row.label">
                                                    </div>
                                                    <div class="col-3">
                                                        <select class="form-control rounded" :name="'questionSettings[answers]['+key+'][type]'" v-model="row.type" >
                                                            <option value="radio" selected="selected">Radio Button</option>
                                                            <option value="checkbox">Check box</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-1 text-right">
                                                        <button type="button" class="btn btn--only-icon-rounded btn--danger" @click="rmAnswerMatrix(key)" ><i class="fas fa-times"></i></button>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="row mb-3 align-items-end">
                                        <div class="col-2">
                                            <div class="form-group">
                                                <label>Answer</label>
                                                <input class="form-control rounded" v-model="newAnswerMatrix" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <label>Type</label>
                                                <select class="form-control rounded"  v-model="newTypeMatrix" >
                                                    <option value="radio" selected="selected">Radio Button</option>
                                                    <option value="checkbox">Check box</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-4 text-right">
                                            <div class="form-group">
                                                <button class="btn btn--green" type="button" @click="addRowAnswerMatrix">Add new answer</button>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    
                                    <div class="row">
                                        <div class="col-12">
                                            <hr>
                                        </div>
                                        <div class="col-12 mt-3 text-right" v-if="can_write">
                                            <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </section>
                    </section>
                </div>
            </vs-popup>
        </div>
    </template>
    
    <script>
    export default {
        
        props: {
            can_write:{
                type:Boolean,
                required:true,
            }
        },
        data () {
            return {
                newIdRow    : "",
                newIdLabel  : "",
                newAnswerId : "",
                newAnswerMatrix : "",
                newTypeMatrix   : "radio",
                matrixRows  : Object,
                matrixAnswers: Object,
                
                //default
                title: "Matrix",
                active : false,
                action : "",
                name:"",
                description:"",
                sorting:-1,
                editing : true,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        methods: {
            
            rmRowMatrix(index){
                //Delete element
                Vue.delete(this.matrixRows,index);
            },
            rmAnswerMatrix(index){
                //Delete element
                Vue.delete(this.matrixAnswers,index);
            },
            addRowAnswerMatrix(){
                //Check if
                if ( this.newAnswerMatrix ==='' ){
                    alert("Non puoi inserire una risposta vuota");
                    return;
                }
                
                this.matrixAnswers.push({"label": this.newAnswerMatrix,"type" : this.newTypeMatrix});
                //Clean variables
                this.newAnswerMatrix = "";
                this.newTypeMatrix = "radiobutton";
            },
            addRowMatrix(){
                //Check if
                if ( this.newIdRow ==='' || this.newIdLabel===''){
                    return false;
                }
                if (this.newIdRow in this.matrixRows ){
                    alert("Indice già inserito");
                    return false;
                }
                this.matrixRows[this.newIdRow] = this.newIdLabel;
                //Clean variables
                this.newIdRow = "";
                this.newIdLabel = "";
            },
            toggle(action, item_id, editing, attributes) {
                
                this.active     = true;
                this.action     = action;
                this.editing    = editing;
                this.lang       = attributes.lang;
                let dataRoute   = decodeURI(attributes.dataRoute);
                if (dataRoute!==undefined) {
                    if (dataRoute.indexOf("[id]")>0) {
                        dataRoute = dataRoute.replace("[id]", item_id);
                        
                    }
                    axios.get(dataRoute)
                    .then((response) => {
                        this.matrixRows = response.data.questions;
                        this.matrixAnswers = response.data.answers;
                        this.name = response.data.base.name;
                        this.description = response.data.base.description;
                        this.sorting = response.data.base.sorting;
                        this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);           
                        
                    });
                }
            }
            
        }
        
    }
</script>
<style>
.hidden {
    display: none !important;
}
</style>

